var render = function render(){var _vm=this,_c=_vm._self._c;return _c('person-thumb',{attrs:{"name":`${_vm.staff.first_name} ${_vm.staff.last_name}`,"image-url":_vm.staff.profile_image,"job-title":_vm.staff.job_title || '',"company":_vm.staff.company_name || '',"to":_vm.contactUrl}})
}
var staticRenderFns = []

export { render, staticRenderFns }